import { render, staticRenderFns } from "./EventFeedLikeBoard.vue?vue&type=template&id=1c1f3f23&scoped=true"
import script from "./EventFeedLikeBoard.vue?vue&type=script&lang=js"
export * from "./EventFeedLikeBoard.vue?vue&type=script&lang=js"
import style0 from "./EventFeedLikeBoard.vue?vue&type=style&index=0&id=1c1f3f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1f3f23",
  null
  
)

export default component.exports